if ($('#app-form-post-edit').length) {

    var progress_loader_steps = 0;
    var progress_loader_curr_step = 0;
    var update_progress_loader = function (message, steps) {
        var container = $('#progressloader');

        progress_loader_curr_step++;
        width = (progress_loader_curr_step / progress_loader_steps) * 100;
        container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
        if (steps === true) {
            message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
        }
        container.find('span').html(message + '...');
        if(progress_loader_steps <= progress_loader_curr_step)
            close_progress_loader();
    };

    var init_progress_loader = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;

        update_progress_loader(message);

        $('#progressloader').show();
    };

    var close_progress_loader = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloader').hide();
    };

    var nielsen_market_radio;
    var flight_dates;
    var ppm_market='<option value="Metro">MSA</option>';
    var no_ppm_market='<option value="Metro">MSA</option>\n' +
        '                    <option value="TSA">TSA</option>\n' +
        '                    <option value="DMA">DMA</option>';
    show_loader();
    $.ajax({
        type: "GET",
        url: '/ratings/radio/markets',
        dataType: 'json',
        success: function (data) {
            hide_loader();
            console.log(data);
            nielsen_market_radio=data;
        },
        error: function (xhr) {
            hide_loader();
            ajax_error();
            debug(xhr.responseText);
        }
    });

    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };

    var playback_types_all = {
        'LO': 'Live Only',
        'LS': 'Live Plus Same Day',
        'L3': 'Live Plus 3',
        'L7': 'Live Plus 7',
        'L1': 'Live Plus 1'
    };
    $('#advertiser').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });

    $('#campaign').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#market').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#stations').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-info btn-outline m-r-5 btn-sm " value="Select All" id="select_all_station">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-info btn-outline m-r-5 btn-sm ' value='Deselect All' id='deselect_all_station'>" +'</div>',
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });
    $('.div_stations ').on('click','#select_all_station', function () {
        $('#stations').multiSelect('select_all');
    })
    $('.div_stations').on('click', '#deselect_all_station',function () {
        $('#stations').multiSelect('deselect_all');
    })
    $('#form_share').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#form_hut').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#form_geography').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#start').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10000
    });
    $('#end').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10000
    });

    $('#invoices').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-info btn-outline m-r-5 btn-sm " value="Select All" id="select_all_invoices">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-info btn-outline m-r-5 btn-sm ' value='Deselect All' id='deselect_all_invoices'>" +'</div>',
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });
    $('.div_invoices').on('click', '#select_all_invoices',function () {
        $('#invoices').multiSelect('select_all');
    })
    $('.div_invoices').on('click', '#deselect_all_invoices',function () {
        $('#invoices').multiSelect('deselect_all');
    })
    $('#form_books').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div class='' style='height: 38px;'> </div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values) {
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });
    $('#name').val(report.name);
    var adv_id= $('#advertiser option:selected').val();
    if(typeof adv_id!=='undefined' && adv_id!=''){
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/post/getCampaigns/' + adv_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var html='<option></option>';
                for(var i in data) {
                    var selected='';
                    if(data[i].id== report.campaign_id)
                        selected='selected';
                    html += '<option value="' + data[i].id + '" '+selected+'>' + data[i].name + '</option>';
                }
                $('#campaign').html(html);
                var camp_id= $('#campaign option:selected').val();
                if(typeof camp_id!=='undefined' && camp_id!=''){
                    $('.books_help').hide();
                    show_loader();
                    $.ajax({
                        type: 'GET',
                        url: '/post/campaign/getMarkets/' + camp_id,
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            var data=response.markets;
                            $('.demo_help').html('');
                            $('.demo_help').html('<span style="color: silver; ">'+response.demos+'</span>');
                            $('.demo_help').show();
                            var html='<option></option>';
                            for(var i in data) {
                                var selected = parseInt(report.market_code) === parseInt(data[i].code) && data[i].type === report.type ? 'selected' : '';
                                html += '<option value="' + data[i].code + '" data-type="' + data[i].type + '" '+selected+'>' + data[i].type.toUpperCase() + '- ' + data[i].market_name + '</option>';
                            }
                            $('#market').html(html);
                            hide_loader();
                            var camp_id= $('#campaign option:selected').val();
                            var market_code= $('#market option:selected').val();

                            if(typeof camp_id!=='undefined' && camp_id!='' && typeof market_code!=='undefined' && market_code!=''){
                                $('#div_books_empty').hide();
                                if($('#market option:selected').attr('data-type')=='dma') {
                                    show_loader();
                                    $('#media_type').val('dma');
                                    $.ajax({
                                        type: "GET",
                                        url: '/ratings/tv/local/monthly/allbooks/?dma=' + market_code,
                                        dataType: 'json',
                                        success: function (data) {
                                            // var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();
                                            var form_playbacks = collect(data).keyBy('playback_type').all();
                                            var input = $('#form_playback_type');
                                            input.attr('disabled', null);
                                            input.html('').append('<option value=""></option>');
                                            $.each(form_playbacks, function (index, value) {
                                                var selected='';
                                                if(index== report.playback_type)
                                                    selected='selected';
                                                input.append('<option value="' + index + '" '+selected+'>' + playback_types_all[index] + '</option>')
                                            });
                                            input.select2({
                                                placeholder: "Select...",
                                                minimumResultsForSearch: 10
                                            });
                                            hide_loader();
                                            var  form_curr_playback = $('#form_playback_type option:selected').val();
                                            var market_code= $('#market option:selected').val();
                                            show_loader();
                                            $.ajax({
                                                type: "GET",
                                                url: '/ratings/tv/local/monthly/books/?dma=' +market_code + '&playback=' + form_curr_playback,
                                                dataType: 'json',
                                                success: function (data) {
                                                   // console.log('edit asdasdasdasdadasdddddddddddddddddddd');
                                                    console.log(data);
                                                    form_books = data;
                                                    // var input = $('#form_hut');
                                                    // input.attr('disabled', null);
                                                    // $('#form_hut').html('');
                                                    // input.html('').append('<option value=""></option>');
                                                    // $.each(data, function (index, value) {
                                                    //     var selected='';
                                                    //     if(value[id] == report.hut)
                                                    //         selected='selected';
                                                    //     input.append('<option value="' + value['id'] + '" '+selected+'>' + value['name'] + '</option>')
                                                    // });
                                                    input = $('#form_share');
                                                    input.attr('disabled', null);
                                                    $('#form_share').html('');
                                                    input.html('').append('<option value=""></option>');
                                                    $.each(data, function (index, value) {
                                                        var selected='';
                                                        if(value['id'] == report.share)
                                                            selected='selected';

                                                        input.append('<option value="' + value['id'] + '" '+selected+'>' + value['name'] + '</option>')
                                                    });
                                                    hide_loader();
                                                },
                                                error: function (xhr) {
                                                    ajax_error();
                                                    hide_loader();
                                                }
                                            });
                                        },
                                        error: function (xhr) {
                                            hide_loader();
                                            ajax_error();
                                            debug(xhr.responseText);
                                        }
                                    });
                                    $('#general_books_div').show();
                                    $('#div_geography').hide();
                                    $('#div_books_radio').hide();
                                    $('#div_books_tv').show();

                                    $('.metric_impressions').html('Thousands');
                                    $('#div_metrics').show();
                                }
                                else{
                                    show_loader();
                                    $('#media_type').val('msa');
                                    for(var i in nielsen_market_radio){
                                        if(nielsen_market_radio[i].code== market_code){
                                            if (nielsen_market_radio[i].type !== 'PPM') {
                                                var input = $('#form_geography');
                                                input.attr('disabled', null);
                                                input.html('');
                                                var hh='';
                                                var ar=['Metro', 'TSA', 'DMA'];
                                                for(var i in ar){
                                                    var sel='';
                                                    if(report.geography== ar[i])
                                                        sel='selected';
                                                    if(ar[i]=='Metro')
                                                        hh+='<option value="Metro" '+sel+'>MSA</option>';
                                                    else
                                                        hh+='<option value="'+ar[i]+'" '+sel+'>'+ar[i]+'</option>';
                                                }
                                                input.html(hh);
                                                $('.ppm_market_text').hide();
                                            }
                                            else{
                                                var input = $('#form_geography');
                                                input.attr('disabled', 'disabled');
                                                input.html('');
                                                input.html(ppm_market);
                                                $('.ppm_market_text').show();
                                            }
                                        }
                                    }
                                    $.ajax({
                                        type: "GET",
                                        url: '/ratings/radio/books/?code=' + market_code,
                                        dataType: 'json',
                                        success: function (data) {
                                            data = Object.values(data)
                                            data.sort(function (a, b) {
                                                var keyA = new Date(a.end)
                                                var keyB = new Date(b.end);
                                                if (keyA > keyB) return -1;
                                                if (keyA < keyB) return 1;
                                                return 0;
                                            });
                                            collect('report.books ', report.books);
                                            var input = $('#form_books');
                                            input.attr('disabled', null);
                                            input.html('');
                                            input.multiSelect('refresh');
                                            $.each(data, function (index, value) {
                                                var selected='';
                                                if( report.books.indexOf(value['id']) !== -1)
                                                    selected='selected';
                                                input.append('<option value="' + value['id'] + '" '+selected+'>' + value['name'] + '</option>')
                                            });
                                            input.multiSelect('refresh');
                                            hide_loader();
                                        },
                                        error: function (xhr) {
                                            ajax_error();
                                            hide_loader();
                                        }
                                    });
                                    $('#general_books_div').show();
                                    $('#div_geography').show();
                                    $('#div_books_radio').show();
                                    $('#div_books_tv').hide();
                                    $('.metric_impressions').html('Hundreds');
                                    $('#div_metrics').show();
                                }
                                show_loader();
                                $.ajax({
                                    type: 'GET',
                                    url: '/post/campaign/market/getStations/' + camp_id+'/'+ market_code+ '/'+  $('#market option:selected').attr('data-type'),
                                    dataType: 'json',
                                    encode: true,
                                    success: function (response) {
                                        var data= response.stations;
                                        $('.books_help').html('');
                                        $('.books_help').html('<span style="color: silver; ">'+response.books+'</span>');
                                        $('.books_help').show();
                                        var html='';
                                        var sta = [];
                                        for(var x in report.stations)
                                            sta.push(parseInt(report.stations[x]));
                                        console.log('report.stations ----- sta', sta);
                                        for(var i in data) {
                                            var selected='';
                                            if(sta.indexOf(parseInt(data[i].id)) !== -1)
                                                selected = 'selected';
                                            console.log('---- ', data[i].id, sta.indexOf(parseInt(data[i].id)));
                                            html += '<option value="' + data[i].id + '" '+selected+'>' + data[i].name + '</option>';
                                        }
                                        $('#stations').html(html).multiSelect('refresh');
                                        var params = {
                                            campaign: $('#campaign option:selected').val(),
                                            market: $('#market option:selected').val(),
                                            market_type: $('#market option:selected').attr('data-type'),
                                            stations: $('#stations').val(),
                                        };
                                        $('#invoices').html('').multiSelect('refresh');
                                        if($('#stations').val().length > 0){
                                            show_loader();
                                            $.ajax({
                                                type: 'POST',
                                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                                data: JSON.stringify(params),
                                                url: '/post/campaign/market/station/getInvoices',
                                                dataType: "json",
                                                contentType: "application/json",
                                                success: function (response) {
                                                    var html='';
                                                    console.log(response);
                                                    console.log(report.invoices);
                                                    var sta = [];
                                                    sta = {imported:[], manual:[]};
                                                    for(var m in report.invoices) {
                                                        for(var x in report.invoices[m])
                                                            sta[m].push(parseInt(report.invoices[m][x]));
                                                    }
                                                    console.log('sta.... invoices', sta);
                                                    for (var i in response) {
                                                        var selected='';
                                                        if(response[i].type=='Imported')
                                                            var xx='imported';
                                                        else
                                                            var xx='manual';
                                                        if( sta[xx].indexOf(response[i].id) !== -1)
                                                            selected='selected';
                                                        console.log(xx);
                                                        console.log(sta[xx].indexOf(response[i].id));
                                                        html += '<option value="' + response[i].type + '_' + response[i].id + '" '+selected+'>' + response[i].number + '  (' + response[i].type + ')</option>';
                                                    }
                                                    $('#invoices').html(html).multiSelect('refresh');
                                                    hide_loader();
                                                },
                                                error: function (xhr) {
                                                    hide_loader();
                                                    ajax_error();
                                                    debug(xhr.responseText);
                                                }
                                            });
                                        }
                                        else hide_loader();

                                    },
                                    error: function (xhr) {
                                        hide_loader();
                                        ajax_error();
                                        debug(xhr.responseText);
                                    }
                                });
                            }

                        },
                        error: function (xhr) {
                            hide_loader();
                            ajax_error();
                            debug(xhr.responseText);
                        }
                    });
                }
                else
                    hide_loader();

            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    $('#advertiser').on('change', function () {
        $('#campaign').html('');
        $('#market').html('');
        $('#stations').html('').multiSelect('refresh');
        $('#start').html('');
        $('#end').html('');
        $('#invoices').html('').multiSelect('refresh');
        $('#general_books_div').hide();
        $('#div_geography').hide();
        $('.demo_help').hide();
        $('.books_help').hide();
        $('#div_books_empty').show();
        $('#form_secondary_demos').html('');
        global_campaign_demos = '';
        var adv_id= $('#advertiser option:selected').val();
        if(typeof adv_id!=='undefined' && adv_id!=''){
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/getCampaigns/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html='<option></option>';
                    for(var i in data)
                        html+='<option value="'+data[i].id +'">'+data[i].name +'</option>';
                    $('#campaign').html(html);
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#campaign').on('change', function () {
        $('#market').html('');
        $('#stations').html('').multiSelect('refresh');
        $('#start').html('');
        $('#end').html('');
        $('#invoices').html('').multiSelect('refresh');
        $('#general_books_div').hide();
        $('#div_geography').hide();
        $('#div_books_empty').show();
        var camp_id= $('#campaign option:selected').val();
        if(typeof camp_id!=='undefined' && camp_id!=''){
            show_loader();
            $('.books_help').hide();
            $.ajax({
                type: 'GET',
                url: '/post/campaign/getMarkets/' + camp_id,
                dataType: 'json',
                encode: true,
                success: function (response) {
                    var data=response.markets;
                    $('.demo_help').html('');
                    $('.demo_help').html('<span style="color: silver; ">'+response.demos+'</span>');
                    $('.demo_help').show();
                    var html='<option></option>';
                    for(var i in data)
                        html+='<option value="'+data[i].code +'" data-type="'+data[i].type+'">'+data[i].type.toUpperCase()+'- '+data[i].market_name +'</option>';
                    $('#market').html(html);
                    global_campaign_demos = response.campaign_demos;
                    $('#form_secondary_demos').select2({
                        placeholder: "Select one...",
                        minimumResultsForSearch: 5
                    }).html('');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
        else {
            $('.demo_help').hide();
            $('.books_help').hide();
        }

    });
    $('#market').on('change', function () {
        $('#stations').html('').multiSelect('refresh');
        $('#invoices').html('').multiSelect('refresh');
        $('#form_hut').html('').attr('disabled', 'disabled');
        $('#form_share').html('').attr('disabled', 'disabled');
        var v_type = $('#market option:selected').attr('data-type');
        var html_d = '';
        if(typeof global_campaign_demos[v_type] !== 'undefined') {
            for (var i in global_campaign_demos[v_type])
                html_d += '<option value="' + global_campaign_demos[v_type][i].id + '">' + global_campaign_demos[v_type][i].demo_type.toUpperCase() + '- ' + global_campaign_demos[v_type][i].demo_name + '</option>';
        }
        $('#form_secondary_demos').select2({
            placeholder: "Select one...",
            minimumResultsForSearch: 5
        }).html(html_d);

        $('.form_secondary_demos_div').show();
        var camp_id= $('#campaign option:selected').val();
        var market_code= $('#market option:selected').val();
        if(typeof camp_id!=='undefined' && camp_id!='' && typeof market_code!=='undefined' && market_code!=''){
            show_loader();
            $('#div_books_empty').hide();
            var cont=0;
            if($('#market option:selected').attr('data-type')=='dma') {
                $('#media_type').val('dma');
                $.ajax({
                    type: "GET",
                    url: '/ratings/tv/local/monthly/allbooks/?dma=' + market_code,
                    dataType: 'json',
                    success: function (data) {
                        // var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();
                        var form_playbacks = collect(data).keyBy('playback_type').all();
                        var input = $('#form_playback_type');
                        input.attr('disabled', null);
                        input.html('').append('<option value=""></option>');
                        $.each(form_playbacks, function (index, value) {
                            input.append('<option value="' + index + '">' + playback_types_all[index] + '</option>')
                        });
                        input.select2({
                            placeholder: "Select...",
                            minimumResultsForSearch: 10
                        });
                        input.bind('change', function () {
                            tvOnPlaybackChange();
                        });
                        if (cont >= 1)
                            hide_loader();
                        else
                            cont++;
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
                $('#general_books_div').show();
                $('#div_geography').hide();
                $('#div_books_radio').hide();
                $('#div_books_tv').show();
            }
            else{
                $('#media_type').val('msa');
                for(var i in nielsen_market_radio){
                    if(nielsen_market_radio[i].code== market_code){
                        if (nielsen_market_radio[i].type !== 'PPM') {
                            var input = $('#form_geography');
                            input.attr('disabled', null);
                            input.html('');
                            input.html(no_ppm_market);
                            $('.ppm_market_text').hide();
                        }
                        else{
                            var input = $('#form_geography');
                            input.attr('disabled', 'disabled');
                            input.html('');
                            input.html(ppm_market);
                            $('.ppm_market_text').show();
                        }

                    }
                }
                $.ajax({
                    type: "GET",
                    url: '/ratings/radio/books/?code=' + market_code,
                    dataType: 'json',
                    success: function (data) {
                        data = Object.values(data)
                        data.sort(function (a, b) {
                            var keyA = new Date(a.end)
                            var keyB = new Date(b.end);
                            if (keyA > keyB) return -1;
                            if (keyA < keyB) return 1;
                            return 0;
                        });
                        var input = $('#form_books');
                        input.attr('disabled', null);
                        input.html('');
                        input.multiSelect('refresh');
                        $.each(data, function (index, value) {
                            input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                        });
                        input.multiSelect('refresh');
                        hide_loader();
                    },
                    error: function (xhr) {
                        ajax_error();
                        hide_loader();
                    }
                });
                $('#general_books_div').show();
                $('#div_geography').show();
                $('#div_books_radio').show();
                $('#div_books_tv').hide();
            }
            $.ajax({
                type: 'GET',
                url: '/post/campaign/market/getStations/' + camp_id+'/'+ market_code,
                dataType: 'json',
                encode: true,
                success: function (response) {
                    var data= response.stations;
                    $('.books_help').html('');
                    $('.books_help').html('<span style="color: silver; ">'+response.books+'</span>');
                    $('.books_help').show();
                    var html='';
                    for(var i in data)
                        html+='<option value="'+data[i].id +'" >'+data[i].name +'</option>';
                    $('#stations').html(html).multiSelect('refresh');
                    if(cont >=1)
                        hide_loader();
                    else
                        cont++;
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    var tvOnPlaybackChange = function(){
        var  form_curr_playback = $('#form_playback_type option:selected').val();
        var market_code= $('#market option:selected').val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/books/?dma=' +market_code + '&playback=' + form_curr_playback,
            dataType: 'json',
            success: function (data) {
                form_books = data;
                var input = $('#form_hut');
                input.attr('disabled', null);
                $('#form_hut').html('');
                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                });
                input.bind('change', function () {
                    tvRankerOnBooksChange(false, 0);
                });
                input = $('#form_share');
                input.attr('disabled', null);
                $('#form_share').html('');
                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                });

                input.bind('change', function () {
                    tvRankerOnBooksChange(false, 0);
                });
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    $('#stations').on('change', function () {
        $('#invoices').html('').multiSelect('refresh');
        if($('#stations').val().length > 0){
            show_loader();
            var params = {
                campaign: $('#campaign option:selected').val(),
                market: $('#market option:selected').val(),
                stations: $('#stations').val(),
                market_type: $('#market option:selected').attr('data-type'),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/post/campaign/market/station/getInvoices',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var html='';
                    for (var i in response)
                        html+='<option value="'+response[i].type+'_'+response[i].id+'">'+response[i].number+'  ('+response[i].type+' Bm: '+ response[i].broadcast_month +')</option>';
                    $('#invoices').html(html).multiSelect('refresh');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#form_submit').on('click', function () {
        var market_code= $('#market option:selected').val();
        if($('#name').val() !='') {
            if (typeof market_code !== 'undefined' && market_code != '') {
                var invoices = $('#invoices').val().length;
                if (invoices > 0) {
                    if ($('#market option:selected').attr('data-type') == 'msa') {
                        var books = $('#form_books').val().length;
                        if (books == 0)
                            global_notification('warning', 'Please select at least one book...');
                        else {
                            var values='';
                            $('#form_books option').each( function () {
                                console.log($(this));
                                console.log($(this).text());
                                if($(this).is(':selected')) {
                                    if (values == '')
                                        values = $(this).text();
                                    else
                                        values += ', ' + $(this).text();
                                }
                            });
                            $('#books_name').val(values);
                            show_loader();
                            init_progress_loader(2, 'This query might take a few seconds. Please wait ...');
                            $('#app-form-post-edit').submit();
                        }
                    } else {
                       // var hut = $('#form_hut').val().length;
                        var share = $('#form_share').val().length;
                        $('#share_name').val($('#form_share option:selected').html());
                       // $('#hut_name').val($('#form_hut option:selected').text());
                        if ( share == 0)
                            global_notification('warning', 'Please select a Book...');
                        else {
                            show_loader();
                            init_progress_loader(2, 'This query might take a few seconds. Please wait ...');
                            $('#app-form-post-edit').submit();
                        }
                    }
                } else
                    global_notification('warning', 'Please select at least one invoice...');
            } else
                global_notification('warning', 'Please select a market...');
        }
        else
            global_notification('warning', 'Report Name is required...');

    });

    $('#form_secondary_demos').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('.form_secondary_demos_div').show();

}
